
export function isIos() {
  const agent = navigator.userAgent.toLowerCase()
  const android = agent.indexOf('android')
  const iphone = agent.indexOf('iphone')
  const ipad = agent.indexOf('ipad')
  if (android !== -1) {
    return false
  }
  if (iphone !== -1 || ipad !== -1) {
    return true
  }
  return false
}

window.setupWebViewJavascriptBridge = (callback) => {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

window.callHandler = (name, data, callback) => {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler(name, data, callback)
  })
}
window.registerHandler = (name, callback) => {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.registerHandler(name, (data, responseCallback) => {
      callback(data, responseCallback)
    })
  })
}

export function initJavascriptBridge() {
  if (isIos()) {
    window.setupWebViewJavascriptBridge(bridge => {
      // bridge 初始化成功
      window.nativeToH5Bridge = bridge
    })
  }
}

export function callNativeMethod(method, data, callback) {
  if (isIos()) {
    console.log('call-native-method', `method:${method}----data:${JSON.stringify(data)}`)
    if (window.nativeToH5Bridge) {
      if (method === 'onWebPageBack') {
        window.nativeToH5Bridge.callHandler('interactivePopGesture', true)
      }
      window.nativeToH5Bridge.callHandler(method, data, callback)
    } else {
      window.setupWebViewJavascriptBridge(bridge => {
        // bridge 初始化成功
        window.nativeToH5Bridge = bridge
        if (method === 'onWebPageBack') {
          window.nativeToH5Bridge.callHandler('interactivePopGesture', true)
        }
        window.nativeToH5Bridge.callHandler(method, data, callback)
      })
    }
  } else {
    if (window.H5ToNative) {
      console.log('call-native-method', `method:${method}----data:${JSON.stringify(data)}}`)
      if (!window.H5ToNative[method]) {
        return
      }
      const result = (data !== undefined && data !== null) ? window.H5ToNative[method](data) : window.H5ToNative[method]()
      callback && callback(result)
    }
  }
}

/**
 * 注册原生调用h5方法
 * @param method
 * @param callback
 */
export function registH5Method(method, callback) {
  if (isIos()) {
    if (window.nativeToH5Bridge) {
      window.nativeToH5Bridge.registerHandler(method, callback)
    } else {
      window.setupWebViewJavascriptBridge(bridge => {
        // bridge 初始化成功
        window.nativeToH5Bridge = bridge
        window.nativeToH5Bridge.registerHandler(method, callback)
      })
    }
  } else {
    if (window.NativeToH5) {
      window.NativeToH5[method] = callback
    } else {
      window.NativeToH5 = {}
      window.NativeToH5[method] = callback
    }
  }
}

/**
 * H5调用原生接口
 * @param {*} method 方法
 * @param {*} args 参数列表
 * @param {*} callback
 */
export function htmlToNative(method, args, callback) {
  const action = { method, args }
  const jsonString = JSON.stringify(action)
  callNativeMethod('htmlToNative', jsonString, (result) => {
    callback && callback(result)
  })
}

/**
 * 返回
 */
export function onWebPageBack() {
  callNativeMethod('onWebPageBack')
}
